import { render, staticRenderFns } from "./confirmation-submit-modal.vue?vue&type=template&id=6aa501ec&scoped=true"
import script from "./confirmation-submit-modal.vue?vue&type=script&lang=js"
export * from "./confirmation-submit-modal.vue?vue&type=script&lang=js"
import style0 from "./confirmation-submit-modal.vue?vue&type=style&index=0&id=6aa501ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa501ec",
  null
  
)

export default component.exports